import { formatNroDocumentoVenta } from '../../utils/formatters';

export function formatCantidadPicking(value?: number | null): string {
  const n = Number(value ?? 0);
  return (Number.isFinite(n) ? n : 0).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
}

export function formatComprobantePicking(doc: {
  nroFormulario: number;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
}): string {
  return formatNroDocumentoVenta(doc.letra, doc.nroSuc, doc.nroComprobante) || `#${doc.nroFormulario}`;
}
